import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { SubscriptionReqTable } from "../../components/SubscriptionReqTable/SubscriptionReqTable";
import { SubscriptionSetup } from "../../components/SubscriptionSetup/SubscriptionSetup";
import Box from "@amzn/awsui-components-react-v3/polaris/box";
import SpaceBetween from "@amzn/awsui-components-react-v3/polaris/space-between";
import AppLayout from "@amzn/awsui-components-react-v3/polaris/app-layout";
import Flashbar from "@amzn/awsui-components-react-v3/polaris/flashbar";
import Header from '@amzn/awsui-components-react-v3/polaris/header';
import Link from '@amzn/awsui-components-react-v3/polaris/link';
import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTE_SKILLBUILDER_SUBSCRIPTION_MANAGEMENT } from "../../common/routes";
import { useHelpPanel, DashboardMainInfo, HelpPanelProvider } from "./help-panel";
import { SessionKey } from "../../common/constants";
export const InfoLink = (props) => {
    const { t } = useTranslation();
    return (_jsx(Link, { variant: "info", ...props, children: t("subscription_request_table_info") }));
};
export const SubscriptionManagementPage = () => {
    const { t } = useTranslation();
    const appLayoutRef = useRef(null);
    useEffect(() => {
        sessionStorage.removeItem(SessionKey.AWS_ACCOUNT_ID);
        sessionStorage.removeItem(SessionKey.AWS_ACCOUNT_JWT);
    }, []);
    return (_jsx(SubscriptionManagementPageContent, { t: t }));
};
const SubscriptionManagementPageContent = ({ t }) => {
    const loadHelpPanelContentInfo = useHelpPanel();
    return (_jsxs(SpaceBetween, { size: "m", "data-testid": 'subscription-management-page', children: [_jsx(Box, { variant: "h1", children: _jsx(Header, { variant: "h1", children: t("subscription_management_page_header") }) }), _jsx(SubscriptionSetup, {}), _jsx(SubscriptionReqTable, {})] }));
};
export const SubscriptionManagementPageLayout = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    const appLayoutRef = useRef(null);
    const [toolsOpen, setToolsOpen] = useState(false);
    const [toolsContent, setToolsContent] = useState(() => _jsx(DashboardMainInfo, {}));
    useEffect(() => {
        if (state?.notification) {
            setItems([
                {
                    type: state?.notification?.type,
                    dismissible: true,
                    content: state?.notification?.text,
                    onDismiss: () => {
                        setItems([]);
                        navigate(ROUTE_SKILLBUILDER_SUBSCRIPTION_MANAGEMENT, {});
                    },
                }
            ]);
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }, [state?.notification]);
    const loadHelpPanelContent = (content) => {
        setToolsOpen(true);
        setToolsContent(content);
        appLayoutRef.current?.focusToolsClose();
    };
    return (_jsx(HelpPanelProvider, { value: loadHelpPanelContent, children: _jsx(AppLayout, { ref: appLayoutRef, content: _jsx(SubscriptionManagementPage, {}), toolsHide: false, toolsOpen: toolsOpen, tools: toolsContent, navigationHide: true, notifications: _jsx(Flashbar, { items: items }), onToolsChange: ({ detail }) => setToolsOpen(detail.open) }) }));
};
